module.exports = __webpack_public_path__ + "img/11.e56f7ea9.png";